/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface StyleCriterion
 */
export interface StyleCriterion {
  /**
   *
   * @type {number}
   * @memberof StyleCriterion
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof StyleCriterion
   */
  name: string;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof StyleCriterion
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {string}
   * @memberof StyleCriterion
   */
  definition: string;
  /**
   *
   * @type {string}
   * @memberof StyleCriterion
   */
  example: string;
  /**
   *
   * @type {number}
   * @memberof StyleCriterion
   */
  scale?: number;
}

/**
 * Check if a given object implements the StyleCriterion interface.
 */
export function instanceOfStyleCriterion(value: object): value is StyleCriterion {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('definition' in value) || value['definition'] === undefined) return false;
  if (!('example' in value) || value['example'] === undefined) return false;
  return true;
}

export function StyleCriterionFromJSON(json: any): StyleCriterion {
  return StyleCriterionFromJSONTyped(json, false);
}

export function StyleCriterionFromJSONTyped(json: any, ignoreDiscriminator: boolean): StyleCriterion {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    definition: json['definition'],
    example: json['example'],
    scale: json['scale'] == null ? undefined : json['scale'],
  };
}

export function StyleCriterionToJSON(value?: Omit<StyleCriterion, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    task_type: TaskTypeEnumToJSON(value['taskType']),
    definition: value['definition'],
    example: value['example'],
    scale: value['scale'],
  };
}
